<template>
  <div class="wrapper">
    <svg width="22" height="22" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9072 0C16.8239 0 17.5555 0.746277 17.5557 1.65234C17.5557 2.90867 18.5651 3.9158 19.7959 3.91602H20.2588C21.2267 3.91602 22 4.70442 22 5.66211V6.62207C22 13.1791 18.4696 19.2244 12.7715 22.4121L12.3506 22.6475C11.5108 23.1172 10.4892 23.1172 9.64941 22.6475L9.22852 22.4121C3.53043 19.2244 0 13.1791 0 6.62207V5.66211C0 4.70441 0.773321 3.91602 1.74121 3.91602H2.2041C3.43494 3.9158 4.44434 2.90867 4.44434 1.65234C4.4445 0.746275 5.17612 0 6.09277 0H15.9072ZM11 15.75C8.98229 15.75 7.26008 16.4602 6.19141 17.4746C7.33382 18.7308 8.68173 19.8148 10.2051 20.667L10.626 20.9023C10.8589 21.0325 11.1411 21.0325 11.374 20.9023L11.7949 20.667C13.3183 19.8148 14.6662 18.7308 15.8086 17.4746C14.7399 16.4602 13.0177 15.75 11 15.75ZM6.42871 2C6.25298 4.18642 4.43552 5.91581 2.2041 5.91602H2V6.62207C2 10.0106 3.06087 13.2422 4.93945 15.9121C5.63764 15.2801 6.48741 14.7666 7.43848 14.3994C6.32662 13.4147 5.625 11.977 5.625 10.375C5.625 7.40651 8.03153 5.00007 11 5C13.9685 5 16.375 7.40647 16.375 10.375C16.375 11.9774 15.6728 13.4147 14.5605 14.3994C15.5117 14.7665 16.3612 15.2801 17.0596 15.9121C18.9384 13.2421 20 10.0108 20 6.62207V5.91602H19.7959C17.5645 5.91581 15.747 4.18642 15.5713 2H6.42871ZM11 7C9.1361 7.00007 7.625 8.51108 7.625 10.375C7.625 12.2389 9.1361 13.7499 11 13.75C12.864 13.75 14.375 12.239 14.375 10.375C14.375 8.51104 12.864 7 11 7Z" fill="black"/>
      </svg>
  </div>
</template>

<script>

export default {
  name: 'UserSetting'
}
</script>

<style lang="scss" scoped>
.wrapper {
  cursor: pointer;

  path {
      transition: 0.5s;
    }

  @media(any-hover: hover) {
    &:hover {
      path {
        fill: #6D6D6D;
        transition: 0.5s;
      }
    }
  }

  &:active {
    path{
      fill: #595959;
      transition: 0.3s ease;
    }
  }
}

</style>
